import { useEffect, useRef, useState } from "react";

export const CustomerChat = () => {
    const customerList = [
        {
            id: 1,
            name: "Venkatesh",
            conversation: [
                {
                    sender: "customer",
                    message: "Hello, I need help with my order.",
                    datetime: "2025-08-28 10:15 AM",
                },
                {
                    sender: "support",
                    message: "Sure Venkatesh, can you please provide your order number?",
                    datetime: "2025-08-28 10:16 AM",
                },
                {
                    sender: "customer",
                    message: "Yes, the order number is #12345.",
                    datetime: "2025-08-28 10:18 AM",
                },
                {
                    sender: "support",
                    message: "Thank you! I’ll check the details and update you shortly.",
                    datetime: "2025-08-28 10:20 AM",
                },
            ],
        },
        {
            id: 2,
            name: "Kiran Kumar",
            conversation: [
                {
                    sender: "customer",
                    message: "Can you assist me with my account?",
                    datetime: "2025-08-27 02:30 PM",
                },
                {
                    sender: "support",
                    message: "Of course Kiran! Are you facing login issues or billing issues?",
                    datetime: "2025-08-27 02:32 PM",
                },
                {
                    sender: "customer",
                    message: "I cannot log in to my account.",
                    datetime: "2025-08-27 02:35 PM",
                },
                {
                    sender: "support",
                    message: "Got it. I’ll send a password reset link to your email.",
                    datetime: "2025-08-27 02:36 PM",
                },
            ],
        },
        {
            id: 3,
            name: "Ravi Teja",
            conversation: [
                {
                    sender: "customer",
                    message: "I have a question about my invoice.",
                    datetime: "2025-08-26 09:00 AM",
                },
                {
                    sender: "support",
                    message: "Sure Ravi Teja, could you tell me the invoice number?",
                    datetime: "2025-08-26 09:02 AM",
                },
                {
                    sender: "customer",
                    message: "It’s INV-7890.",
                    datetime: "2025-08-26 09:05 AM",
                },
                {
                    sender: "support",
                    message: "Thanks! I checked and the invoice has already been paid.",
                    datetime: "2025-08-26 09:07 AM",
                },
            ],
        },
        {
            id: 4,
            name: "Suresh Babu",
            conversation: [
                {
                    sender: "customer",
                    message: "Hi, I want to change my delivery address.",
                    datetime: "2025-08-28 11:10 AM",
                },
                {
                    sender: "support",
                    message: "No problem Suresh Babu, please provide your new address.",
                    datetime: "2025-08-28 11:12 AM",
                },
                {
                    sender: "customer",
                    message: "Sure, it’s 123 Green Street, Springfield.",
                    datetime: "2025-08-28 11:15 AM",
                },
                {
                    sender: "support",
                    message: "Got it! I’ve updated your delivery address successfully.",
                    datetime: "2025-08-28 11:18 AM",
                },
            ],
        },
        {
            id: 5,
            name: "Sophia Williams",
            conversation: [
                {
                    sender: "customer",
                    message: "Do you have discounts for new customers?",
                    datetime: "2025-08-29 08:45 AM",
                },
                {
                    sender: "support",
                    message: "Yes Sophia, we have a 10% discount on the first purchase.",
                    datetime: "2025-08-29 08:46 AM",
                },
                {
                    sender: "customer",
                    message: "That’s great! How can I apply it?",
                    datetime: "2025-08-29 08:48 AM",
                },
                {
                    sender: "support",
                    message: "Just use the code WELCOME10 at checkout.",
                    datetime: "2025-08-29 08:50 AM",
                },
            ],
        },
    ];
    const [selectedCustomer, setSelectedCustomer] = useState(customerList[0]);
    const [message, setMessage] = useState("");
    const chatWindowRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (chatWindowRef.current) {
            chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
        }
    }, [selectedCustomer.conversation]);

    const sendMessage = () => {
        if (message.trim()) {
            const newMessage = {
                sender: "support",
                message,
                datetime: new Date().toLocaleString(),
            };
            setSelectedCustomer((prev) => ({
                ...prev,
                conversation: [...prev.conversation, newMessage],
            }));
            setMessage("");
        }
    };

    function formatDateTime(input: string): string {
        let date: Date;

        if (/^\d{4}-\d{2}-\d{2} \d{1,2}:\d{2} (AM|PM)$/i.test(input)) {
            return input;
        }

        if (/^\d{2}\/\d{2}\/\d{4},/.test(input)) {
            const [datePart, timePart] = input.split(",");
            const [day, month, year] = datePart.trim().split("/");
            date = new Date(`${year}-${month}-${day}T${timePart.trim()}`);
        } else {
            date = new Date(input);
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    }

    return (
        <div className="">
            <div className="row m-0 p-0">
                {/* Left side customer list */}
                <div className="col-3 ">
                    <div className="container-fluid content-bg-color p-2 px-3" style={{ minHeight: "87dvh" }}>
                        <h4 className="fw-bold mb-2 mt-1">Customer List</h4>
                        {customerList.map((customer: any, index: any) => (
                            <div
                                key={index}
                                className={`p-2 rounded mb-1 cursor-pointer ${selectedCustomer?.id === customer.id ? "primary-bg text-white" : "chatting-bg text-dark"
                                    }`}
                                onClick={() => setSelectedCustomer(customer)}
                            >
                                {customer.name}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right side chat */}
                <div className="col-9 px-0 d-flex flex-column" style={{ height: "87dvh" }}>
                    {selectedCustomer && (
                        <>
                            <h4 className="fw-bold mb-2 mt-1 chatting-bg p-2 rounded-3">{selectedCustomer.name}</h4>

                            {/* 👇 attach ref here */}
                            <div ref={chatWindowRef} className="flex-grow-1 overflow-auto px-2">
                                {selectedCustomer.conversation.map((msg: any, index: any) => (
                                    <div key={index} className={`${msg.sender === "support" ? "text-end" : "text-start"} mb-1`}>
                                        <div
                                            className={`card d-inline-block box-shadow border-0 mb-2 ${msg.sender === "support" ? "chatting-bg" : "bg-light"
                                                }`}
                                            style={{ maxWidth: "70%", wordBreak: "break-word" }}
                                        >
                                            <div className="card-body p-2">
                                                <div>{msg.message}</div>
                                                <div className="text-end fs-12">{formatDateTime(msg.datetime)}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Input */}
                            <div className="p-2 border-top d-flex align-items-center">
                                <input
                                    type="text"
                                    className="form-control me-2"
                                    placeholder="Type a message..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                                />
                                <button
                                    className="btn btn-primary d-flex align-items-center justify-content-center"
                                    onClick={() => sendMessage()}
                                >
                                    <i className="bi bi-chevron-double-right"></i>
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
